module.exports = __webpack_public_path__ + "329ae1c377b1fb667f5be6abd50327fc.ttf";


//////////////////
// WEBPACK FOOTER
// ./application/font/Roboto-Regular.ttf
// module id = 344
// module chunks = 0